import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Contact } from './components/Contact';
import { PitchPopup } from './components/PitchPopup';
export function App() {
  return <div className="min-h-screen bg-zinc-50 font-sans selection:bg-zinc-200 selection:text-zinc-900" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <Contact data-id="element-5" />
      </main>

      {/* Footer */}
      <footer className="bg-zinc-950 text-zinc-500 py-8 text-center text-sm border-t border-white/5" data-id="element-6">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-7">
          <p data-id="element-8">
            © {new Date().getFullYear()} Адвокатське бюро. Всі права захищені.
          </p>
          <p data-id="element-9">Військові, кримінальні та цивільні справи.</p>
        </div>
      </footer>

      {/* Agency Pitch Popup */}
      <PitchPopup data-id="element-10" />
    </div>;
}